'use client'

import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface, PLTypedWidgetProps } from '@src/components/pl-base-widget'
import CUSTOM_SECTION_TYPE from '@src/quince-site-common/src/domains/CustomSectionType'
import CollectionPromoBanner from '@src/SectionRenderer/sections/collectionBanner/CollectionBanner'
import HeroBanner from '@src/SectionRenderer/sections/heroBanner'

import { buildCollectionPromoBannerConfig, buildHeroBannerConfig, hasBannerContent } from '../banner-section-builders'

import type { CollectionBannerWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

const CollectionBannerWidgetComponent = (props: PLTypedWidgetProps<CollectionBannerWidgetData>) => {
  const bannerData = props.data.collectionBannerData
  if (!bannerData || !hasBannerContent(bannerData)) {
    return null
  }

  const sectionType = bannerData.sectionType as CUSTOM_SECTION_TYPE

  switch (sectionType) {
    case CUSTOM_SECTION_TYPE.COLLECTION_PROMO_BANNER:
      return <CollectionPromoBanner sectionConfig={buildCollectionPromoBannerConfig(bannerData)} />
    case CUSTOM_SECTION_TYPE.HERO_CAROUSEL:
    case CUSTOM_SECTION_TYPE.HERO_BANNER:
    default:
      return <HeroBanner sectionConfig={buildHeroBannerConfig(bannerData)} />
  }
}

export const CollectionBannerWidget: PLTypedWidgetInterface<CollectionBannerWidgetData, WidgetType.COLLECTION_BANNER> =
  {
    id: WidgetType.COLLECTION_BANNER,
    errorBoundary: PLBaseErrorBoundary,
    render: CollectionBannerWidgetComponent,
  }
